import type { AmountDto, QuoteComponentDto } from '..';

type SimplfiedQuote = {
  totalPremium: AmountDto;
  components: QuoteComponentDto[];
};

export function getComponent(quote: SimplfiedQuote | undefined, id: string) {
  return quote?.components.find(component => component.id === id);
}

export function getBrokerageFirmFees(quote: SimplfiedQuote | undefined, brokerageFirmId?: string) {
  // It's a bit easier to define config if the brokerageFirmId is optional, while it should be required
  // Thus we return undefined to avoid accidentally showing the total fees, while it is specically what we want to avoid
  // The PremiumModule should properly handle queries loading and else so it's not an issue
  if (!brokerageFirmId) {
    return undefined;
  }

  return quote?.totalPremium?.fees
    .filter(fee => fee.brokerageFirmId === brokerageFirmId)
    .reduce((acc, fee) => acc + (fee.amount ?? 0), 0);
}
